import { useQuery } from '@tanstack/react-query';

import {
  getInvestmentAllocation,
  listInvestmentHoldings,
  listInvestmentTheses,
} from '../../lib/api/endpoints';
import { investmentThesisKeys } from '../../lib/investmentQueryKeys';

export { investmentThesisKeys } from '../../lib/investmentQueryKeys';

export function useInvestmentTheses(accountId: string | null, includeClosed = false) {
  return useQuery({
    queryKey: [...investmentThesisKeys.list(accountId), { includeClosed }],
    queryFn: () => listInvestmentTheses(accountId ?? '', includeClosed),
    enabled: Boolean(accountId),
  });
}

export function useInvestmentHoldings(accountId: string | null) {
  return useQuery({
    queryKey: investmentThesisKeys.holdings(accountId),
    queryFn: () => listInvestmentHoldings(accountId ?? ''),
    enabled: Boolean(accountId),
  });
}

export function useInvestmentAllocation(accountId: string | null) {
  return useQuery({
    queryKey: investmentThesisKeys.allocation(accountId),
    queryFn: () => getInvestmentAllocation(accountId ?? ''),
    enabled: Boolean(accountId),
  });
}
